import React, { memo, useCallback } from "react";

import { TextField, InputAdornment } from "@mui/material";

import type { Locale } from "../types";
import localization from "../localization";

type DepositComponentProps = {
  locale: Locale;
  inputRef: React.RefObject<React.MutableRefObject<HTMLInputElement | null>>;
  label: string;
  defaultValue: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const DepositComponent = memo((props: DepositComponentProps) => {
  const { locale, inputRef, label, defaultValue, onBlur, onKeyDown } = props;

  const { currencySign } = localization[locale];

  // Limit user input to positive integer values
  const handleInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      e.target.value = "";
    } else {
      e.target.value = parseInt(e.target.value) > 0 ? parseInt(e.target.value).toString() : "0";
    }
  }, []);

  return (
    <TextField
      inputRef={inputRef}
      placeholder="0"
      fullWidth={true}
      label={label}
      variant="outlined"
      defaultValue={defaultValue}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onInput={handleInput}
      InputProps={{
        startAdornment: <InputAdornment position="start">{currencySign}</InputAdornment>,
      }}
    />
  );
});

export default DepositComponent;
